var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-name-remark"},[_c('div',{staticClass:"unr-name"},[_vm._v(_vm._s(_vm.displayName))]),(_vm.displayRemark)?_c('div',{staticClass:"unr-remark"},[_vm._v(_vm._s(_vm.displayRemark))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }